// blog data
import img1 from "../assets/Images/internship.jpeg"
import img2 from "../assets/Images/Screenshot_20-8-2024_185613_www.hackerrank.com.jpeg"
import img3 from "../assets/Images/Screenshot_20-8-2024_18582_www.hackerrank.com.jpeg"
import img4 from "../assets/Images/Screenshot_20-8-2024_185943_www.hackerrank.com.jpeg"
import img5 from "../assets/Images/Js.jpeg"
import img6 from "../assets/Images/Frontend.jpeg"
import img8 from "../assets/Images/Screenshot_20-8-2024_19221_infyspringboard.onwingspan.com.jpeg"
import img9 from "../assets/Images/Screenshot_20-8-2024_1948_infyspringboard.onwingspan.com.jpeg"
import img10 from "../assets/Images/Screenshot_20-8-2024_19722_.jpeg"
import img11 from "../assets/Images/Screenshot_20-8-2024_192637_.jpeg"


export const Blogs = [
    {
        id:1,
        name:"Internship at Octanet Services Pvt Ltd",
        tags:[ "Internship", "HTML", "CSS","Java-Script"],
        date:"1st July, 2024 - 1st August , 2024",
        imgSrc: img1,
        link:"https://api.certifypro.in/page/verification"
    },
    {
        id:2,
        name:"IoT-Based Robotics Training Internship - eYantra",
        tags:["IoT", "Robotics", "Internship", "e-Yantra"],
        date:"17 March, 2023",
        imgSrc: img10,
        link:"#"
    },
    {
        id:3,
        name:"Data Science Certification - IBM",
        tags:["Data Science", "IBM"],
        date:"19 August, 2023",
        imgSrc: img11,
        link:"https://courses.skillsbuild.skillsnetwork.site/certificates/122b0109d11e4ae497dfa8a593446297"
    },
    {
        id:4,
        name:"Problem Solving Intermediate",
        tags:["HackerRank", "problem-solving", "certificate"],
        date:"17 July, 2024",
        imgSrc: img2,
        link:"https://www.hackerrank.com/certificates/b05789f5da2d"
    },
    
    {
        id:5,
        name:"SQL Intermediate Certification",
        tags:["SQL", "Data Analysis", "Certification"],
        date:"10 July, 2024",
        imgSrc: img3,
        link:"https://www.hackerrank.com/certificates/00de8ec1d8c4"
    },
    {
        id:6,
        name:"SQL Advanced Certification",
        tags:["SQL", "Advanced SQL", "Certification"],
        date:"10 July, 2024",
        imgSrc: img4,
        link:"https://www.hackerrank.com/certificates/701a96a1d378"
    },
    {
        id:7,
        name:"JavaScript Intermediate Certification",
        tags:["JavaScript", "Web Development", "Certification"],
        date:"12 July, 2024",
        imgSrc:img5,
        link:"https://www.hackerrank.com/certificates/fd9b97040ce9"
    },
    {
        id:8,
        name:"Web Development Certification",
        tags:["Frontend Development", "HTML", "CSS", "Java-Script"],
        date:"24 July, 2024",
        imgSrc:img6,
        link:"https://verify.onwingspan.com/"

    },

    {
        id:9,
        name:"Python Foundation Certification",
        tags:["Python", "Certification", "Infosys-Springboard"],
        date:"5 August, 2024",
        imgSrc:img8,
        link:"https://verify.onwingspan.com/"
    },
    {
        id:10,
        name:"AI Primer Certification",
        tags:["AI","Certification", "Infosys Springboard"],
        date:"17 Feb, 2024",
        imgSrc:img9,
        link:"https://verify.onwingspan.com/"
    }
] 